// extracted by mini-css-extract-plugin
export default {"settingsDropdown":"calendar_settingsDropdown__9VR2d","stickyHeader":"calendar_stickyHeader__Z6KVq","topicList":"calendar_topicList__ZTL4Z"};